export default "__VITE_ASSET__BflQxvuA__"